const s = {
  name: "Podcast",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,0c-4.4,0-8,3.6-8,8v12c0,4.4,3.6,8,8,8s8-3.6,8-8V8C28,3.6,24.4,0,20,0z M14,8c0-3.3,2.7-6,6-6s6,2.7,6,6
			v12c0,3.3-2.7,6-6,6s-6-2.7-6-6V8z"/>
		<path class="st0" d="M20,30c-5.5,0-10-4.5-10-10H8c0,6.3,4.8,11.5,11,12v6h-5v2h12v-2h-5v-6c6.2-0.5,11-5.7,11-12h-2
			C30,25.5,25.5,30,20,30z"/>
		<path class="st0" d="M10,11v6H8v-6H10z"/>
		<path class="st0" d="M2,20V8H0v12H2z"/>
		<path class="st0" d="M32,11v6h-2v-6H32z"/>
		<path class="st0" d="M36,23V5h-2v18H36z"/>
		<path class="st0" d="M6,5v18H4V5H6z"/>
		<path class="st0" d="M40,20V8h-2v12H40z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Podcast
};
